import { useCallback, useEffect, useState } from "react";
import { listDocCategories } from "@/lib/document/docClient";
import type { DocCategoryNode } from "@/lib/document/categoryTypes";

export function useDocumentCategories(enabled: boolean) {
  const [tree, setTree] = useState<DocCategoryNode[]>([]);
  const [flatCategories, setFlatCategories] = useState<Omit<DocCategoryNode, "children">[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [seededDefaults, setSeededDefaults] = useState(false);

  const reload = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    setError(null);
    const r = await listDocCategories();
    setLoading(false);
    if (!r.ok) {
      setError(r.error);
      return;
    }
    setTree(r.data.tree);
    setFlatCategories(r.data.categories);
    setSeededDefaults(r.data.seeded_defaults);
    setSelectedCategoryId((prev) => {
      if (prev && r.data.categories.some((c) => c.id === prev)) return prev;
      return r.data.tree[0]?.id ?? null;
    });
  }, [enabled]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return {
    tree,
    flatCategories,
    selectedCategoryId,
    setSelectedCategoryId,
    loading,
    error,
    seededDefaults,
    reload,
  };
}
